export default [
  {
    path: '/yujianfenzhen',
    name: 'yujianfenzhen',
    meta: { title: '预检分诊' },
    component: () => import(/* webpackChunkName: "yujianfenzhen" */ '../views/yujianfenzhen/yujianfenzhen')
  },
  {
    path: '/yujianfenzhenForm',
    name: 'yujianfenzhenForm',
    meta: { title: '预检分诊表填写' },
    component: () => import(/* webpackChunkName: "yujianfenzhen" */ '../views/yujianfenzhen/components/yujianfenzhenForm')
  },
  {
    path: '/yujianfenzhenList',
    name: 'yujianfenzhenList',
    meta: { title: '预检分诊表列表' },
    component: () => import(/* webpackChunkName: "yujianfenzhen" */ '../views/yujianfenzhenList/yujianfenzhenList')
  },
  {
    path: '/yujianfenzhenUser',
    name: 'yujianfenzhenUser',
    meta: { title: '预检分诊表列表' },
    component: () => import(/* webpackChunkName: "yujianfenzhen" */ '../views/yujianfenzhen/yujianfenzhenUser')
  }
]
